window.$ = $;

window.alert = function(message, type = 'danger') {
    const icons = {
        success: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        danger:  '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2.5"/><path d="M12 7v6M12 16.5v.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>',
        warning: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3l10 18H2L12 3z" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round"/><path d="M12 10v4M12 17.5v.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>',
        info:    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2.5"/><path d="M12 11v6M12 7.5v.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>',
    };
    const icon = icons[type] || icons.info;

    // Don't stack an identical toast that's still on screen.
    const alreadyShown = $('.toast-container .toast.show .c-toast__body')
        .filter(function () { return $(this).text() === message; })
        .length > 0;
    if (alreadyShown) return;

    const $toast = $(`
        <div class="toast c-toast c-toast--${type}" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="c-toast__inner">
                <span class="c-toast__icon">${icon}</span>
                <span class="c-toast__body">${message}</span>
                <button type="button" class="c-toast__close" data-bs-dismiss="toast" aria-label="Zamknij">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>
                </button>
            </div>
        </div>
    `);
    $toast.on('hidden.bs.toast', function () { $(this).remove(); });
    $('.toast-container').prepend($toast);
    $toast.toast('show');
};

(function () {
    let redirecting = false;
    const _fetch = window.fetch;

    window.fetch = async function (...args) {
        const response = await _fetch(...args);

        if (!redirecting && (response.status === 401 || response.status === 403)) {
            const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url ?? '');
            if (url.startsWith('/api')) {
                redirecting = true;
                window.alert('Twoja sesja wygasła. Za chwilę zostaniesz przekierowany do logowania…', 'warning');
                setTimeout(() => { window.location.href = '/login'; }, 2000);
            }
        }

        return response;
    };
}());

window.escapeHTML = function(unsafe)
{
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};

// przenosi pojedyncze znaki z końca linijki na początek następnej
export function addNbsps(el) {
    $(el).find(":not(iframe):not(style):not(script)").add(el).contents().filter((i, n) => n.nodeType == 3).each(function () {
        var startWhitespace = /^\s/.test(this.nodeValue) ? ' ' : '';
        var endWhitespace = /\s$/.test(this.nodeValue) ? ' ' : '';
        this.nodeValue = startWhitespace + (' ' + this.nodeValue + ' ').replace(/(\s\w)\s+/g, "$1\xA0").trim() + endWhitespace;
    });
};

addNbsps('body');

$('[data-bs-toggle="tooltip"]').tooltip();

import './prelaunch-subscribe';